/*
 * ORIO haptic feedback helpers.
 * Uses the Vibration API where supported (Android Chrome, Samsung Internet, some PWAs).
 * Silently no-ops on iOS Safari (Apple does not expose navigator.vibrate to web pages).
 */

const canVibrate = () =>
  typeof navigator !== "undefined" && typeof navigator.vibrate === "function";

/** Subtle tap — used for normal CTA buttons. */
export function hapticTap() {
  if (canVibrate()) {
    try { navigator.vibrate(15); } catch (_) { /* ignore */ }
  }
}

/** Medium thump — used for success / confirmation. */
export function hapticSuccess() {
  if (canVibrate()) {
    try { navigator.vibrate([20, 40, 20]); } catch (_) { /* ignore */ }
  }
}

/** Strong alert pattern — used for SOS / emergencies. */
export function hapticEmergency() {
  if (canVibrate()) {
    try { navigator.vibrate([60, 30, 60, 30, 120]); } catch (_) { /* ignore */ }
  }
}

/** Light double-tick — used for swipe gestures (like / pass). */
export function hapticSwipe() {
  if (canVibrate()) {
    try { navigator.vibrate([10, 30, 10]); } catch (_) { /* ignore */ }
  }
}

/** Warning double-buzz — used for radar hazard proximity alerts during walks. */
export function hapticWarning() {
  if (canVibrate()) {
    try { navigator.vibrate([40, 80, 40, 80, 40]); } catch (_) { /* ignore */ }
  }
}

